var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ScorecardDashboardPane"},[_c('div',{staticClass:"container-fluid container-fill"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"paper"},[_c('div',{staticClass:"tab-content"},[_c('Scorecard')],1)])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }